import React from 'react';
import Logo from './kml.png'

function About(){
    return (
        <>  
           <div className='divresult'>
            <div style={{display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#8080800a',
    width:'100%'}}>
            <h1 style={{marginRight:'10px'}}>created by  </h1>
                    < a href='https://www.instagram.com/kamal_soni_____/' target='_blank' rel="noreferrer"
                    style={{    marginTop: 'auto'}}>
                <img src={Logo} height='30px' width='30px' /></a>
           </div>
            </div>
        </>
    )
}

export default About;